import {
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  HostBinding,
  Input, Renderer2, ViewContainerRef,
  OnInit,
} from '@angular/core';
import { PivotSpinnerComponent } from './pivot-spinner.component';
import { PivotSize } from './pivot-spinner.size';

@Directive({
  selector: '[pivotSpinner]',
})
export class PivotSpinnerDirective implements OnInit {
  @HostBinding('class.nb-spinner-container') isSpinnerExist = false;
  @Input() pivotSpinnerSize: PivotSize = 'medium';

  private spinner: ComponentRef<PivotSpinnerComponent>;
  private componentFactory: ComponentFactory<PivotSpinnerComponent>;
  private shouldShow = false;

  constructor(
    private el: ElementRef,
    private directiveView: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private renderer: Renderer2,
  ) { }

  @Input()
  set pivotSpinner(val: boolean) {
    if (this.componentFactory) {
      if (val) {
        this.show();
      } else {
        this.hide();
      }
    } else {
      this.shouldShow = val;
    }
  }

  ngOnInit() {
    this.componentFactory = this.componentFactoryResolver.resolveComponentFactory(PivotSpinnerComponent);
    if (this.shouldShow) {
      this.show();
    }
  }

  hide() {
    if (this.isSpinnerExist) {
      this.directiveView.remove();
      this.isSpinnerExist = false;
    }
  }

  show() {
    if (!this.isSpinnerExist) {
      this.spinner = this.directiveView.createComponent<PivotSpinnerComponent>(this.componentFactory);
      this.spinner.instance.inside = true;
      this.setInstanceInputs(this.spinner.instance);
      this.spinner.changeDetectorRef.detectChanges();
      this.renderer.appendChild(this.el.nativeElement, this.spinner.location.nativeElement);
      this.isSpinnerExist = true;
    }
  }

  setInstanceInputs(instance: PivotSpinnerComponent) {
    if (typeof this.pivotSpinnerSize !== 'undefined') {
      instance.size = this.pivotSpinnerSize;
    }
  }
}
